<div id="login-register-modal" class="p-10 rounded-[10px] w-[400px] max-w-[90vw] sm:!mt-[60px]">
    <img src="/assets/images/white_logo.png" class="w-[113px] mx-auto mb-7" alt="csakjegyek.hu">
    <button (click)="hideModal()" type="button" id="closeButton" role="button"><app-x></app-x></button>
    <app-login-register-content [auth]="auth"></app-login-register-content>
</div>
